import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DashboardComponent } from './dashboard.component';
import { EditTagComponent } from '../features/manage-tags/edit-tag/edit-tag.component';
import { ManageTagsComponent } from '../features/manage-tags/manage-tags.component';
import { NewTagComponent } from '../features/manage-tags/new-tag/new-tag.component';
import { DeleteTagComponent } from '../features/manage-tags/delete-tag/delete-tag.component';

@NgModule({
  declarations: [
    DashboardComponent, EditTagComponent, ManageTagsComponent, NewTagComponent, DeleteTagComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DashboardRoutingModule,
  ]
})
export class DashboardModule { }
